import {PropertyApi} from "../property/PropertiesPanel";
import elementService, {ElementService} from "./service/ElementService";
import {PropertyCreateDto, PropertyDefinitionDto, PropertyDto} from "../../../../common/apis/property/PropertyApi";
import {ElementPropertyDefinition} from "../../../../common/ElementPropertyDefinitionContext";


export class ElementPropertyWrapperApi implements PropertyApi {

    private readonly apiClient: ElementService;

    constructor(readonly elementId: string,
            readonly propertyDefinitionContext: ElementPropertyDefinition) {
        this.apiClient = elementService;
    }

    getExistingPropertyDefinitions(): PropertyDefinitionDto[] {
        return this.propertyDefinitionContext.propertyDefinitions;
    }

    refreshExistingPropertyDefinitions(): void {
        this.propertyDefinitionContext.updatePropertyDefinitions();
    }

    getProperties(): Promise<PropertyDto[]> {
        return this.apiClient.findAllProperties(this.elementId);
    }

    createProperty(name: string, type: string, value: string, propertyDefinitionId: string | undefined): Promise<PropertyDto> {
        const propertyCreate: PropertyCreateDto = {
            propDefIdentifier: propertyDefinitionId,
            name: name,
            type: type,
            value: value
        };
        return this.apiClient.createProperty(this.elementId, propertyCreate);
    }

    updateProperty(propertyDefinitionId: string, value: string): Promise<void> {
        return this.apiClient.updateProperty(this.elementId, propertyDefinitionId, value);
    }

    deleteProperty(propertyDefinitionId: string): Promise<void> {
        return this.apiClient.deleteProperty(this.elementId, propertyDefinitionId);
    }

}